import { useMemo } from "react";
import { useMyPermissions } from "@/features/permissions/hooks/usePermissionsQueries";

export function useDocumentsPermissions() {
  const { data, isLoading } = useMyPermissions();
  const permissions = useMemo(() => new Set(data?.permissions ?? []), [data]);

  return {
    isLoading,
    canRead: permissions.has("documents:read"),
    canUpload: permissions.has("documents:upload"),
    canManage: permissions.has("documents:manage"),
  };
}
